<template>
  <div>
    <div class="bg-secondary-9 rounded py-1 mb-1 pt-3">
      <div class="collapse-container col d-flex align-items-start">
        <div class="col col-md-9 col-sm-12 justify-content-start align-items-center flex-md-row flex-sm-row" @click="onToggleHandler">
          <icon-view
            :icon-background="iconBackground"
            :icon="toggleIcon"
            icon-size="0.8rem"
            :title="title"
            variant="icon-view__extended ml-n1 cursor-pointer"
          />
        </div>
        <div
          class="col col-md-3 col-sm-12 d-flex justify-content-end align-items-center flex-md-row flex-sm-row"
        >
          <custom-drop-down
            v-if="hasFilters"
            v-model="selectedFilter"
            :clearable="false"
            fieldkey="id"
            fieldname="name"
            :options="filterItems"
            placeholder="Seleccione para filtrar por tipo de PEI"
            class="flex-grow-1 w-100 mr-3"
            @input="$emit('on-change-filter-item', selectedFilter)"
          />
          <dropdown
            v-if="showActions"
            icon="fas fa-print"
            :items="actionSummary()"
            title="Imprimir"
          />
        </div>
      </div>
    </div>
    <div v-if="value">
      <slot />
    </div>
    <div class="row">
      <div class="col color-dark-gray font-weight-bold font-16 d-flex align-items-center">
        <queue-report-status 
          :queue-report="currentIpReport"
          @on-download="onDownloadHandler"
          @on-cancel="onCancelHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IconView from "icon-view";
import Dropdown from "dropdown";
import CustomDropDown from "custom-drop-down";
import QueueReportStatus from './QueueReportStatus.vue';
import queueStatus from '@/utils/constants/queueReportStatus.js';

export default {
  name: "SummaryCollapse",
  components: {
    IconView,
    Dropdown,
    CustomDropDown,
    QueueReportStatus,
  },
  props: {
    isOpened: {
      type: Boolean,
      default: () => false,
    },
    title: {
      type: String,
      default: () => "",
    },
    actionSummary: {
      type: Function,
      default: () => {},
    },
    filterItems: {
      type: Array,
      default: () => [],
    },
    currentIpReport: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      value: this.isOpened,
      selectedFilter: this.filterItems[0],
    };
  },
  computed: {
    iconBackground() {
      return this.value ? "#2DB782" : "#FF7058";
    },
    toggleIcon() {
      return `color-white fas fa-chevron-${this.value ? "down" : "right"}`;
    },
    hasFilters() {
      return this.filterItems?.length > 0;
    },
    showActions() {
      return !([queueStatus.Pending, queueStatus.Running]
      .includes(this.currentIpReport?.statusId ?? 0));
    },
  },
  methods: {
    onToggleHandler() {
      this.value = !this.value
      this.$emit("on-toggle", this.value)
    },
    onDownloadHandler(executionLogId) {
      this.$emit("on-download", executionLogId);
    },
    onCancelHandler(executionLogId) {
      this.$emit("on-cancel", executionLogId);
    },
  },
};
</script>

<style scoped lang="scss">
.icon-view__extended ::v-deep {
  margin-bottom: 1rem;
  .dot {
    .title-icon {
      margin: 0 !important;
    }
  }
}

@media screen and (max-width: 768px) { 
  .collapse-container {
    flex-direction: column;
    } 
  }
</style>
